// Mock data for Template 3 logistics/transport company website
export const mockRootProps = {
  topContactInfo: {
    phone: "+123 456 789",
    email: "support@domain.com",
    socialMedia: {
      facebook: "#",
      twitter: "#",
      instagram: "#",
      linkedin: "#"
    }
  },
  businessInfo: {
    name: "VISIBEEN",
    logo: "/images/template3-logo.png",
    heroTitle: "We are provide",
    heroSubtitle: "Lorem ipsum dolor",
    heroTagline: "Services For You",
    heroDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
    ctaText: "Explore more"
  },
  navigation: {
    menuItems: ["Home", "About Us", "Services", "Pages", "Blog", "Contact"]
  },
  aboutUs: {
    sectionTag: "Who we are",
    title: "We are global Logistic And Transport Agency",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever se",
    features: [
      {
        title: "Global Service",
        description: "We always provide people a complete solution focused of any business.",
        icon: "global"
      },
      {
        title: "Local Service", 
        description: "We always provide people a complete solution focused of any business.",
        icon: "local"
      }
    ],
    ctaText: "More About Us",
    experienceYears: "25+",
    experienceText: "Years of experience",
    image: "/images/template3-about-bg.png"
  },
  services: {
    sectionTag: "Our Service",
    title: "Provide Efficient Logistics Solutions",
    subtitle: "Business",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
    ctaText: "see more",
    servicesList: [
      {
        id: 1,
        title: "Local Truck Transport",
        description: "A logistic service provide company plays a pivotal role in the global supply logistic global services.",
        image: "/images/template3-service-1.jpg",
        icon: "truck"
      },
      {
        id: 2,
        title: "International Transport",
        description: "A logistic service provide company plays a pivotal role in the global supply logistic global services.",
        image: "/images/template3-service-2.jpg",
        icon: "airplane"
      },
      {
        id: 3,
        title: "Fast Personal Delivery",
        description: "A logistic service provide company plays a pivotal role in the global supply logistic global services.",
        image: "/images/template3-service-3.jpg",
        icon: "delivery"
      }
    ]
  },
  testimonials: [
    {
      id: 1,
      name: "Leslie Alexander",
      role: "Manager",
      review: "A logistic service provide company plays a pivotal role in the global supply chain logistic service provider company a logistic services provider",
      image: "https://i.pravatar.cc/150?img=1",
      rating: 5
    },
    {
      id: 2,
      name: "Leslie Alexander",
      role: "Manager", 
      review: "A logistic service provide company plays a pivotal role in the global supply chain logistic service provider company a logistic services provider",
      image: "https://i.pravatar.cc/150?img=2",
      rating: 5
    },
    {
      id: 3,
      name: "Leslie Alexander",
      role: "Manager",
      review: "A logistic service provide company plays a pivotal role in the global supply chain logistic service provider company a logistic services provider",
      image: "https://i.pravatar.cc/150?img=3", 
      rating: 5
    }
  ],
  faq: {
    sectionTag: "Company's FAQ",
    title: "Frequently Asked Have Any",
    subtitle: "Question?",
    description: "We help businesses bring ideas to life in the digital world designing & implementing the technology tools that they need to win. We help business bring ideas to life in the digital wor",
    ctaText: "Get in touch",
    progressBars: [
      { label: "Special Transport", percentage: 46 },
      { label: "Local Transport", percentage: 32 }
    ],
    questions: [
      {
        id: 1,
        question: "How do you handle returns or exchanges?",
        answer: "We help businesses bring ideas to life in the digital world designing & implementing the technology tools that they need to win. We help business bring ideas to life in the digital wor",
        isExpanded: true
      },
      {
        id: 2,
        question: "What does business consulting do?",
        answer: null,
        isExpanded: false
      },
      {
        id: 3,
        question: "Can I cancel a shipment after it's been booked?",
        answer: null,
        isExpanded: false
      },
      {
        id: 4,
        question: "Can you assist with customs clearance procedures?",
        answer: null,
        isExpanded: false
      }
    ]
  },
  blog: {
    sectionTag: "Latest Blogs",
    title: "Latest Blogs &",
    titleHighlight: "News",
    posts: [
      {
        id: 1,
        title: "Fast and Reliable ShippingGuaranteey Trusted",
        description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
        image: "/images/template3-blog-1.jpg"
      },
      {
        id: 2,
        title: "Cargo Follow Through theBest Supply Your Metal",
        description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
        image: "/images/template3-service-3.jpg"
      },
      {
        id: 3,
        title: "What is the Future of TruckloadTransportation?",
        description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
        image: "/images/template3-blog-2.jpg"
      }
    ]
  },
  contactInfo: {
    address: "Logistic service provider company plays a pivotal role in the global supply chain logistic service provider.",
    phone: "+880 123 456 789",
    email: "Call Now",
    hours: {
      weekdays: "Mon-Fri: 9 AM – 6 PM",
      sunday: "Sunday: Closed",
      label: "Timming"
    },
    logo: "/images/template3-logo.png"
  },
  footer: {
    quickLinks: ["Home", "About Us", "Services", "Blogs", "Contact Us"],
    services: ["Container Freight", "Train Transport", "Container Freight", "Road Freight", "Truck Load"],
    mapImage: "/images/template3-map.svg",
    copyright: "© Copyright 2025 Visibeen. All Rights Reserved",
    socialMedia: {
      facebook: "#",
      twitter: "#",
      instagram: "#",
      linkedin: "#"
    }
  },
  location: {
    title: "Find Us",
    subtitle: "Visit our location or reach out to us for more information",
    address: "Logistic service provider company plays a pivotal role in the global supply chain"
  }
};